import { inject } from 'mobx-react';
import React from 'react';
import { injectIntl, intlShape } from 'react-intl';

import PropTypes from 'prop-types';
import globalTranslations from '../../../i18n/globalTranslations';
import { modelOf } from '../../../prop-types';
import ConfigStore from '../../../store/ConfigStore';
import PageTitle from '../../common/PageTitle';
import SEOHomePage from '../../head/SEOHomePage';
import AccountModal from '../AccountModal';
import SetNewPasswordForm from '../SetNewPasswordForm';

const LoginRequired = ({ configStore, intl, token }) => {
  const hasToken = !!token;
  const title =
    configStore.configurationTexts.CONF_SEO_TITLE ||
    intl.formatMessage(globalTranslations.homeTitle);

  return (
    <div className="LoginRequired">
      <SEOHomePage />
      <PageTitle itemProp={title}>{title}</PageTitle>
      {hasToken ? (
        <SetNewPasswordForm passwordResetToken={token} />
      ) : (
        <AccountModal key={'LoginRequired'} useAsModal={false} />
      )}
    </div>
  );
};

LoginRequired.propTypes = {
  configStore: modelOf(ConfigStore).isRequired,
  intl: intlShape.isRequired,
  token: PropTypes.string,
};

export default injectIntl(inject('configStore')(LoginRequired));
